import { useMemo } from 'react';

// we need to read the CSRF Token from somewhere that's not a cookie.  Because we're embedding an iframe, this
// makes it a bit safer than trying to make our CSRF Cookie temporarily SameSite: None, which isn't good from security perspective

const useCsrfToken = () => {
  // wrapping this in a useMemo so it's more testable. sigh.
  const csrftoken = useMemo(() => document.querySelector('[name=csrfmiddlewaretoken]').value, []); // run this once, it selects the value from the default hidden input the {% csrf_token %} template tag creates

  return csrftoken;
};

export default useCsrfToken;
